import { Grid, useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import MunicipalityList, { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { ItalianForm } from 'shell/view-models/italian-form';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import ParentElement from 'shell/components/shared/parent-element';
import { DateTime } from 'luxon';

interface ItalianComponentProps {
  disabledComponent?: boolean;
  values?: ItalianForm | null;
  errors?: FormikErrors<ItalianForm>;
  touched?: FormikTouched<ItalianForm>;
  isMunicipalityRequired?: boolean;
  onChange: (key: keyof ItalianForm, value: ItalianForm[keyof ItalianForm]) => void;
  labelMunicipality?: string;
  labelProvince?: string;
  birthday?: DateTime | null;
}

const ItalianComponent = ({
  disabledComponent,
  onChange,
  values,
  isMunicipalityRequired = true,
  errors,
  labelMunicipality = 'Comune di residenza',
  labelProvince = 'Provincia di residenza',
  touched,
  birthday,
}: ItalianComponentProps): React.ReactElement => {
  const handleMunicipalityListChange = useEventCallback(
    (municipality: MunicipalityAnprVM | null) => {
      onChange('municipality', municipality);
    }
  );

  return (
    <ParentElement disabledComponent={disabledComponent}>
      {disabledComponent && !Boolean(values?.municipality) ? undefined : (
        <Grid item xs={12} md={3}>
          <MunicipalityList
            value={values?.municipality || null}
            onChange={handleMunicipalityListChange}
            required={isMunicipalityRequired}
            disabled={disabledComponent}
            label={labelMunicipality}
            fromDate={birthday}
            error={
              (touched?.municipality as unknown as FormikTouched<MunicipalityAnprVM>) &&
              Boolean(errors?.municipality as FormikErrors<MunicipalityAnprVM>)
            }
          />
        </Grid>
      )}
      {disabledComponent && !Boolean(values?.municipality?.province) ? undefined : (
        <Grid item xs={12} md={3}>
          <PmiTextField
            aria-label={labelProvince}
            label={labelProvince}
            id="province"
            name="province"
            fullWidth
            disabled
            type="text"
            variant="outlined"
            value={values?.municipality?.province || ''}
            onChange={(event) => {
              onChange('province', event.target.value);
            }}
          />
        </Grid>
      )}
    </ParentElement>
  );
};

ItalianComponent.displayName = 'Italian generality component';

const Italian = memo(ItalianComponent);

export default Italian;
